import * as React from 'react';
import { AppErrorProvider, BlockingErrorBoundary, ErrorNamespaceProvider } from '@edreamsodigeo/frontend-core';
import { BrokenFlowFlights } from '@edreamsodigeo/frontend-price-freeze';
import { Page as ConfirmationPage } from './pages/pfconfirmation';
import { Page as HomePage } from './pages/pfhome';
import { Page as PfoffersPage } from './pages/pfoffers';
import { Page as PaxPage } from './pages/pfpax';
import { Page as PaymentPage } from './pages/pfpayment';
import Container from './Container';
import { PriceFreezeTranslationsProvider } from './Provider';
export const PriceFreezeFunnel = () => /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
  namespace: "shell_funnel_price_freeze"
}, /*#__PURE__*/React.createElement(AppErrorProvider, {
  logService: "/frontend-api"
}, /*#__PURE__*/React.createElement(PriceFreezeTranslationsProvider, null, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
  name: "shell_price_freeze"
}, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(HomePage, null), /*#__PURE__*/React.createElement(PfoffersPage, null), /*#__PURE__*/React.createElement(PaxPage, null), /*#__PURE__*/React.createElement(PaymentPage, null), /*#__PURE__*/React.createElement(ConfirmationPage, null))), /*#__PURE__*/React.createElement(BrokenFlowFlights, null))));